import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  const isDark = theme === 'dark';
  
  return (
    <button
      onClick={toggleTheme}
      className={`glass border p-3 rounded-full transition-all duration-500 flex items-center justify-center cursor-pointer z-50 relative hover:scale-110 ${
        isDark 
          ? 'glass-dark text-white hover:bg-white/10' 
          : 'glass-light text-charcoal hover:bg-white/40'
      }`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <Moon size={20} className="transition-transform duration-500" />
      ) : (
        <Sun size={20} className="transition-transform duration-500" />
      )}
    </button>
  );
};

export default ThemeToggle;
